import { render, staticRenderFns } from "./Detective.vue?vue&type=template&id=f1b28fc8&scoped=true&lang=pug&"
import script from "./Detective.vue?vue&type=script&lang=js&"
export * from "./Detective.vue?vue&type=script&lang=js&"
import style0 from "./Detective.vue?vue&type=style&index=0&id=f1b28fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b28fc8",
  null
  
)

export default component.exports